import React, { useCallback, useState } from "react";
import axios from "../redux/sagas/axios";

const Edit = ({ preferences, initialMyPreferences }) => {
  const [isSelectedIds, setIsSelectedIds] = useState(initialMyPreferences.map((p) => p.id));
  const [myPreferences, setMyPreferences] = useState(initialMyPreferences);

  const onChangePreferenceIds = useCallback((preference) => {
    if (isSelectedIds.includes(preference.id)) {
      setIsSelectedIds(isSelectedIds.filter((id) => id != preference.id))
      setMyPreferences(myPreferences.filter((p) => p.id != preference.id))
    } else {
      const newMyPreferences = preference.preference_type != 1 ? myPreferences.filter((p) => p.preference_type != preference.preference_type) : myPreferences
      setIsSelectedIds(newMyPreferences.map((p) => p.id).concat(preference.id))
      setMyPreferences(newMyPreferences.concat(preference))
    }
  },[myPreferences]);

  const onSubmit = useCallback(() => {
    try {
      const preferenceIds = JSON.stringify({preference_ids: isSelectedIds});
        axios.post("/api/preferences_users", preferenceIds)
        window.location.href = '/preferences/events'
    } catch(e) {
      alert('通信に失敗しました。')
    }
  },[isSelectedIds]);

  let tmp_preference_type = 0;

  return (
    <div>
      <div className="container col-md-8 col-lg-6">
        {preferences.map((preference, index) => {
          const isSelected = isSelectedIds.includes(preference.id)

          if (tmp_preference_type === preference.preference_type){
            tmp_preference_type = preference.preference_type;
            return (
              <label key={index} className={`p-2 m-2 text-fz-12px cursor-pointer badge badge-pill ${isSelected ? 'text-white bg-tunagate-gradation' : 'badge-light'}`}>
                <input
                  type={preference.preference_type != 1 ? "radio" : "checkbox"}
                  checked={isSelected}
                  onChange={() => onChangePreferenceIds(preference)}
                  style={{display: 'none'}}
                />
                {preference.name}
              </label>
            )
          } else {
            tmp_preference_type = preference.preference_type;
            return (
              <span key={index}>
                <h6 className="text-fz-16px text-fw-bold text-left mt-3 pb-2">{preference.description}</h6>
                <label className={`p-2 m-2 text-fz-12px cursor-pointer badge badge-pill ${isSelected ? 'text-white bg-tunagate-gradation' : 'badge-light'}`}>
                <input
                  type={preference.preference_type != 1 ? "radio" : "checkbox"}
                  checked={isSelected}
                  onChange={() => onChangePreferenceIds(preference)}
                  style={{display: 'none'}}
                />
                  {preference.name}
                </label>
              </span>
            )
          }
        })}
      </div>
      <div className="container col-md-8 col-lg-6">
        <button
          className="a-button a-button__top a-button--orange mt-5 mb-5 w-100"
          onClick={() => onSubmit()}
        >
          送信する
        </button>
      </div>
    </div>
  );
};

export default Edit;
